import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  border: none;
  border-radius: 4px;
  padding: 0px;
`;
